export default __webpack_public_path__ + "static/media/polygon.d70ad136.svg";